import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelect", "organizationSection", "brandSection", "campaignSection"]
  static values = {
    brandManagerRole: String,
    brandOwnerRole: String,
    editorRole: String
  }

  connect() {
    this.updateVisibility()
  }

  onChange() {
    this.updateVisibility()
  }

  updateVisibility() {
    const role = this.roleSelectTarget.value

    const isBrandManager = role === this.brandManagerRoleValue
    const isBrandOwner = role === this.brandOwnerRoleValue
    const isEditor = role === this.editorRoleValue

    this.toggle(this.organizationSectionTarget, !(isBrandManager || isBrandOwner || isEditor))
    this.toggle(this.brandSectionTarget, isBrandManager || isBrandOwner)
    this.toggle(this.campaignSectionTarget, isEditor)
  }

  toggle(element, show) {
    if (!element) return
    element.style.display = show ? "block" : "none"
  }
}


